var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4"},[_c('v-textarea',{attrs:{"data-private":"","auto-grow":"","no-resize":"","outlined":"","dense":"","rows":"3","maxlength":140,"counter":140,"placeholder":_vm.label},on:{"input":function($event){return _vm.$emit('commentChanged', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }